import { useInView } from '@/hooks/useInView';
import type { ReactNode } from 'react';

interface AnimateSectionProps {
  children: ReactNode;
  className?: string;
}

export default function AnimateSection({ children, className = '' }: AnimateSectionProps) {
  const { ref, isInView } = useInView(0.1);

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${
        isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      } ${className}`}
    >
      {children}
    </div>
  );
}